<template>
  <video-quick-tour
    :height="videoHeight"
    video-name="explainer_FinancialPlan"
  >
    <h4 class="my-3 my-xl-0 font-outfit-medium">
      {{ $t('welcomeToFinancialPlan') }}
    </h4>
    <div v-html="$t('financialPlanQuickTourText')" />
  </video-quick-tour>
</template>

<script>
import VideoQuickTour from '@/components/_v2/VideoQuickTour'

export default {
  name: 'FinancialPlanQuickTour',

  components: {
    VideoQuickTour
  },

  props: {
    videoHeight: {
      type: String,
      default: '320'
    }
  }
}
</script>
